import FormControl from '~/common/components/Forms/FormControl';
import FormLabel from '~/common/components/Forms/FormLabel';
import Select from '~/common/components/Selects/Select';
import theme from '~/theme/';

type FormBuilderSelectProps = {
  register?: (...args: any[]) => any;
  name?: string;
  label?: string;
  isRequired?: boolean;
  span?: number;
  placeholder?: string;
  dataTestId?: string;
  optionsAttributes?: {
    optionsLabelName?: string;
    optionsValueName?: string;
  };
  options?: {
    key?: string;
    value?: string;
    label?: string;
  }[];
  disabled?: boolean;
  getValues?: (...args: any[]) => any;
  onChangeHandler?: (...args: any[]) => any;
  isOptionDisabled?: (...args: any[]) => any;
  isInvalid?: boolean;
  tabIndex?: number;
};

export const FormBuilderSelect = ({
  name,
  label,
  span,
  placeholder,
  isRequired = false,
  isInvalid,
  getValues,
  onChangeHandler,
  options,
  optionsAttributes,
  isOptionDisabled,
  disabled,
  tabIndex,
  dataTestId,
}: FormBuilderSelectProps) => (
  <FormControl
    style={{ gridColumn: `span ${span}` }}
    isInvalid={isInvalid}
    isRequired={isRequired}
  >
    <FormLabel>{label}</FormLabel>
    <Select
      sx={{
        backgroundColor: disabled ? undefined : theme.colors?.white,
      }}
      value={getValues(name)}
      placeholder={placeholder}
      onChange={(e) => {
        onChangeHandler(e.target.value);
      }}
      tabIndex={tabIndex}
      isDisabled={disabled}
      data-testid={dataTestId}
    >
      {(options ?? []).map((option, i) => (
        <option
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={i}
          value={option[optionsAttributes?.optionsValueName] ?? option.value}
          disabled={isOptionDisabled ? isOptionDisabled(option) : false}
        >
          {option.label ?? option[optionsAttributes?.optionsLabelName]}
        </option>
      ))}
    </Select>
  </FormControl>
);
